import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = {
  key: 2,
  class: "new-list-flag"
}
const _hoisted_3 = { key: 4 }
const _hoisted_4 = { key: 5 }

import { ref, reactive, computed, onMounted, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import CustomerMaps from '@/components/CustomerMaps/index.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import ExportDetails from '@/views/gucangSales/clueManage/salesClue/components/ExportDetails.vue'
import ClueMergeButton from '@/components/ClueMergeButton'
import Modal from '@/hooks/modalType'
import ImportBtn from '@/components/ImportBtn'
import ClueAssign from '../components/ClueAssign.vue'
import { listByParamCodes, addToFav, cancelToFav } from '@/api/common'
import { customerListFormat } from '@/utils'
import { businessTypeEnum, customerUnfollowDayTypeEnum, customerTypeEnum, favoriteStatus } from '@/views/yuntuSales/commonEnum/dataConfig'
import { clueStatusEnum } from '../dataConfig'
import { salesClueList, salesClueDelete, salesClueDetail, salesClueRefund } from '@/api/yuntuSales/clueManage'
import type { ParamCodeItem } from '@/typings/common'
import type { LbuSalesClueParams, LbuSalesClueListItem } from '@/typings/api/clueManage'
import _default from 'ant-design-vue/lib/color-picker'
import FavoriteIcon from '@/components/FavoriteIcon/index.vue'
import RoadAreaSelect from '@/components/roadAreaSelect/src/roadAreaSelect.vue'
import CustomerLabelCascader from '@/components/CustomerLabelCascader/index.vue'
import formatThousandSeparator from '@/utils/format'
import { Modal as AModal } from 'ant-design-vue'


const __default__ = { name: 'DcCosLbuSalesClue' }

import props = _default.props

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()

const exportDetailsRef = ref()
const handleExportDetails = () => {
  exportDetailsRef.value?.init()
}

const statusEnum = clueStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))
// 业务参数
const paramCodeData = reactive<{
  [key: string]: ParamCodeItem[]
}>({
  lbu_source_channel: [], // 来源渠道
  lbu_customer_business_area: [], // 业务地区
  lbu_important: [], // 潜在收入
  lbu_sales_category: [], // 销售品类
  lbu_cargo_type: [], // 货物类型
  lbu_logistics_service_provider: [], // 现有合作物流服务商
  lbu_shipping_channel: [], // 出货渠道
  lbu_daily_traffic: [], // 客户日均包裹数量
  lbu_invalid_reason: [] // 无效原因
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: [
      'lbu_source_channel',
      'lbu_customer_business_area',
      'lbu_important',
      'lbu_sales_category',
      'lbu_cargo_type',
      'lbu_logistics_service_provider',
      'lbu_shipping_channel',
      'lbu_daily_traffic',
      'lbu_invalid_reason'
    ]
  }).then((res) => {
    Object.assign(paramCodeData, res.data)
  })
}
onMounted(() => getByParamCodes())

const tableRef = ref()
const queryForm = reactive<LbuSalesClueParams>({
  sortCollection: 1,
  clueStatus: 3,
  contact: { type: 1 },
  timeSearch: { type: 1 }
})
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    fixed: 'left',
    width: 200
  },
  {
    title: '客户识别码',
    dataIndex: 'customerSerial'
  },
  { title: '客户标签', dataIndex: 'label' },
  {
    title: '业务类型',
    dataIndex: 'businessType',
    dicData: businessTypeEnum
  },
  {
    title: '线索ID',
    dataIndex: 'clueId'
  },
  {
    title: '线索状态',
    dataIndex: 'clueStatus'
  },
  {
    title: '来源渠道',
    dataIndex: 'channel'
  },
  {
    title: '客户负责人',
    dataIndex: 'followerName'
  },
  {
    title: '路区代码',
    dataIndex: 'roadAreaCode'
  },
  {
    title: '前负责人',
    dataIndex: 'beforeFollowerName'
  },
  {
    title: '客户区域',
    dataIndex: 'customerRegion'
  },
  {
    title: '客户类型',
    dataIndex: 'customerType',
    dicData: customerTypeEnum
  },
  {
    title: '未跟进天数',
    dataIndex: 'notFollowDayNum'
  },
  {
    title: '客户合同地址',
    dataIndex: 'customerAddress'
  },
  {
    title: '联系人姓名',
    dataIndex: ['contact', 'name'],
    cosType: 'mask'
  },
  {
    title: '手机号',
    dataIndex: ['contact', 'mobile'],
    cosType: 'mask'
  },
  {
    title: '邮箱',
    dataIndex: ['contact', 'email'],
    cosType: 'mask'
  },
  {
    title: '微信号',
    dataIndex: ['contact', 'wechat'],
    cosType: 'mask'
  },
  {
    title: 'QQ号',
    dataIndex: ['contact', 'qq'],
    cosType: 'mask'
  },
  {
    title: '固定电话',
    dataIndex: ['contact', 'tel'],
    cosType: 'mask'
  },
  {
    title: '传真号',
    dataIndex: ['contact', 'fax']
  },
  {
    title: '备注',
    dataIndex: 'remark'
  },
  // {
  //   title: '业务地区',
  //   dataIndex: ['business', 'businessArea'],
  //   dicData: paramCodeData.lbu_customer_business_area
  // },
  {
    title: '业务收入等级',
    dataIndex: ['business', 'monthIncome'],
    dicData: paramCodeData.lbu_important
  },
  {
    title: '年销售GMV(元)',
    dataIndex: ['business', 'annualSales'],
    type: 'money',
    sorter: true,
    width: 160
  },
  // {
  //   title: '销售品类',
  //   dataIndex: ['business', 'salesCategory'],
  //   dicData: paramCodeData.lbu_sales_category
  // },
  // {
  //   title: '货物类型',
  //   dataIndex: ['business', 'cargoType'],
  //   dicData: paramCodeData.lbu_cargo_type
  // },
  // {
  //   title: '现有合作物流服务商',
  //   dataIndex: ['business', 'cooperativeLogistics'],
  //   dicData: paramCodeData.lbu_logistics_service_provider
  // },
  // {
  //   title: '出货渠道',
  //   dataIndex: ['business', 'deliveryChannel'],
  //   dicData: paramCodeData.lbu_shipping_channel
  // },
  // {
  //   title: '客户日均包裹数量',
  //   dataIndex: ['business', 'dailyTraffic'],
  //   dicData: paramCodeData.lbu_daily_traffic
  // },
  {
    title: '总TPR（元/月）',
    dataIndex: ['business', 'tpr'],
    type: 'money',
    sorter: true
  },
  {
    title: '总TPR（票数/月）',
    dataIndex: ['business', 'totalPotential'],
    type: 'money',
    sorter: true
  },
  {
    title: '首次领取时间',
    dataIndex: 'firstReceiveTime',
    width: 190,
    sorter: true
  },
  {
    title: '最后一次领取时间',
    dataIndex: 'lastReceiveTime',
    width: 190,
    sorter: true
  },
  {
    title: '转潜在客户时间',
    dataIndex: 'stageChangeTime',
    width: 190
  },
  {
    title: '无效原因',
    dataIndex: 'invalidId',
    dicData: paramCodeData.lbu_invalid_reason
  },
  {
    title: '创建人',
    dataIndex: 'createByName'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 190,
    sorter: true
  },
  {
    title: '更新人',
    dataIndex: 'updateByName'
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime',
    width: 190,
    sorter: true
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: 200,
    fixed: 'right'
  }
])
const handledQueryParams = (params: LbuSalesClueParams) => {
  const queryForm = customerListFormat(params) // 处理客户名称和客户编码的批量查询参数
  const contacts = queryForm.contact?.keyword?.split(/[,，\s\n]/).filter((e: string) => e)
  if (contacts && contacts.length > 1) {
    queryForm.contact.keywordList = contacts
    delete queryForm.contact.keyword
  }
  if (queryForm.sortingFields !== undefined) {
    queryForm.sortCollection = undefined
  }
  return queryForm
}
const getList = (queryForm: LbuSalesClueParams, callBack: (res: any) => void) => {
  const params = handledQueryParams(queryForm) // 处理客户名称的批量查询参数
  salesClueList(params).then((res) => {
    callBack(res)
  })
}
// 获取详情联系人信息
const showMask = (record: LbuSalesClueListItem, callBack: (res: any) => void) => {
  salesClueDetail({ clueId: record.clueId }).then((res) => {
    const { contact } = res.data
    callBack(contact)
  })
}
const handleQueryChange = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
const deleteRefresh = (num: number) => {
  const params = toRaw(selectedData.value)
  params.splice(0, num)
  tableRef.value?.delFetch(params, 'clueId')
}

const selectedData = ref<LbuSalesClueListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: LbuSalesClueListItem[]) => {
  selectedData.value = selectedRows
}

// 新增编辑函数
const triggerAddOrEdit = (clueId?: string) => {
  if (clueId) {
    router.push({
      path: '/lbu/salesClue/edit',
      query: { clueId }
    })
  } else {
    router.push('/lbu/salesClue/add')
  }
}
// 跳转写跟进页面
const handleWriteFollowUp = (clueId: string) => {
  router.push({
    path: '/lbu/followUpRecord/add',
    query: {
      followRefId: clueId,
      returnPath: route.fullPath
    }
  })
}
// 分配客户负责人
const clueAssignRef = ref()
const handleAssignPerson = () => {
  if (!selectedData.value.length) return message.warning('请选择需要分配的线索')
  clueAssignRef.value?.init(toRaw(selectedData.value))
}

// 转潜在客户
const handleTurnPotential = (row?: LbuSalesClueListItem) => {
  if (!row) return
  if (row.clueStatus === 5) return message.warning('无效线索不能转潜在客户')
  router.push({
    path: '/lbu/salesClue/potential',
    query: { clueId: row.clueId }
  })
}
const handleDelete = (row?: LbuSalesClueListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.error('请选择要删除的数据')
  }
  const clueIdList: any[] = []
  const customerName = []
  if (row) {
    clueIdList.push(row.clueId)
    customerName.push(row.customerName)
  } else {
    selectedData.value?.forEach((item) => {
      clueIdList.push(item.clueId)
      customerName.push(item.customerName)
    })
  }
  Modal.delete({
    name: customerName.join(','),
    onOk() {
      salesClueDelete({ clueIdList }).then(() => {
        message.success('删除线索成功')
        tableRef.value?.fetch()
        deleteRefresh(0)
      })
    }
  })
}

const handleRefund = () => {
  if (!selectedData.value?.length) {
    return message.error('请选择要退回的数据')
  }
  const clueIdList: any[] = []
  selectedData.value?.forEach((item) => {
    clueIdList.push(item.clueId)
  })
  AModal.confirm({
    title: '退回',
    content: '退回后线索会进入公海池，且不能再领取，是否确定退回？',
    okText: '确定',
    onOk() {
      salesClueRefund({ clueIdList }).then(() => {
        message.success('退回线索成功')
        tableRef.value?.fetch()
        deleteRefresh(0)
      })
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onCancel() {}
  })
}

const customerMapsRef = ref()
const handleMap = (row: LbuSalesClueListItem) => {
  customerMapsRef.value.toggle({
    addressRefId: row.clueId,
    addressRefName: row.customerName
  })
}
// 收藏
const addFavorite = (row: LbuSalesClueListItem, index:number) => {
  addToFav({
    appId: 'cos_lbu',
    cosId: row.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = row.clueId
      tableRef.value?.notifyItem(index, row)
    }
  })
}
// 收藏
const cancelFavorite = (row: LbuSalesClueListItem, index:number) => {
  cancelToFav({
    appId: 'cos_lbu',
    cosId: row.clueId,
    stage: 1
  }).then((res) => {
    if (res.code === 200) {
      row.collectionId = null
      row.collectionTime = null
      tableRef.value?.notifyItem(index, row)
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_dc_layout_main, { "is-breadcrumb": true }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_content, null, {
          default: _withCtx(() => [
            _createVNode(_component_cos_table, {
              serial: "",
              rowKey: "clueId",
              "row-selection": { onChange: onSelectRowsChange },
              columns: columns.value,
              search: queryForm,
              "onUpdate:search": _cache[27] || (_cache[27] = ($event: any) => ((queryForm) = $event)),
              onFetch: getList,
              onMask: showMask,
              ref_key: "tableRef",
              ref: tableRef,
              tableId: "DcCosLbuSalesClue"
            }, {
              search: _withCtx(() => [
                _createVNode(_component_a_form, { model: queryForm }, {
                  default: _withCtx(() => [
                    _createVNode(_component_dc_form_item, { label: "线索状态" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: queryForm.clueStatus,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.clueStatus) = $event)),
                          optionType: "button",
                          options: _unref(clueStatusEnum),
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (handleQueryChange('search')))
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_textarea, {
                          value: queryForm.customerName,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.customerName) = $event)),
                          autoSize: { minRows: 1, maxRows: 4 },
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "联系方式" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: queryForm.contact.type,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.contact.type) = $event)),
                              style: {"width":"33%"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("手机号")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("固定电话")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 3 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("邮箱")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 4 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("微信号")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 5 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("QQ号")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_a_input, {
                              value: queryForm.contact.keyword,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.contact.keyword) = $event)),
                              maxlength: 500,
                              allowClear: "",
                              placeholder: "请输入",
                              style: {"width":"67%"}
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户负责人" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UserSelect, {
                          permission: "",
                          value: queryForm.followerList,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.followerList) = $event)),
                          mode: "multiple",
                          allowClear: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户区域" }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerAreaCascader, {
                          type: "search",
                          appId: "cos_lbu",
                          ids: queryForm.customerRegionList,
                          "onUpdate:ids": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.customerRegionList) = $event))
                        }, null, 8, ["ids"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "员工区域" }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerAreaCascader, {
                          type: "search",
                          appId: "cos_lbu",
                          ids: queryForm.employeeRegionList,
                          "onUpdate:ids": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.employeeRegionList) = $event))
                        }, null, 8, ["ids"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "来源渠道" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(ParamCodeCascader, {
                              type: "search",
                              ids: queryForm.channelList,
                              "onUpdate:ids": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.channelList) = $event)),
                              options: paramCodeData.lbu_source_channel,
                              style: {"width":"33%"}
                            }, null, 8, ["ids", "options"]),
                            _createVNode(_component_a_input, {
                              value: queryForm.channelExplain,
                              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.channelExplain) = $event)),
                              maxlength: 100,
                              style: {"width":"67%"},
                              placeholder: "请输入",
                              allowClear: ""
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "时间筛选" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input_group, { compact: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: queryForm.timeSearch.type,
                              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.timeSearch.type) = $event)),
                              style: {"width":"33%"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("创建时间")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("首次领取时间")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 3 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("最后一次领取时间")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 4 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("转为潜在客户时间")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"]),
                            _createVNode(_component_CosRangePicker, {
                              startTime: queryForm.timeSearch.startTime,
                              "onUpdate:startTime": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.timeSearch.startTime) = $event)),
                              endTime: queryForm.timeSearch.endTime,
                              "onUpdate:endTime": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.timeSearch.endTime) = $event)),
                              style: {"width":"67%"}
                            }, null, 8, ["startTime", "endTime"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "排序" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: queryForm.sortCollection,
                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.sortCollection) = $event)),
                          options: _unref(favoriteStatus),
                          placeholder: "请选择",
                          allowClear: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "未跟进天数" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: queryForm.notFollowDayNumType,
                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((queryForm.notFollowDayNumType) = $event)),
                          options: _unref(customerUnfollowDayTypeEnum),
                          placeholder: "请选择",
                          allowClear: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "线索ID" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.clueId,
                          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((queryForm.clueId) = $event)),
                          maxlength: 500,
                          allowClear: "",
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户识别码" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: queryForm.customerSerial,
                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((queryForm.customerSerial) = $event)),
                          allowClear: "",
                          placeholder: "请输入"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "路区代码" }, {
                      default: _withCtx(() => [
                        _createVNode(RoadAreaSelect, {
                          permission: "",
                          value: queryForm.roadAreaUserList,
                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((queryForm.roadAreaUserList) = $event)),
                          allowClear: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "客户标签" }, {
                      default: _withCtx(() => [
                        _createVNode(CustomerLabelCascader, {
                          type: "search",
                          onlyCommon: false,
                          appId: "cos_lbu",
                          ids: queryForm.labelIdList,
                          "onUpdate:ids": _cache[18] || (_cache[18] = ($event: any) => ((queryForm.labelIdList) = $event)),
                          allowClear: ""
                        }, null, 8, ["ids"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_dc_form_item, { label: "业务类型" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: queryForm.businessTypeList,
                          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((queryForm.businessTypeList) = $event)),
                          options: _unref(businessTypeEnum),
                          placeholder: "请选择",
                          mode: "multiple",
                          allowClear: ""
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              button: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (triggerAddOrEdit()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'lbu_clue_add_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (handleAssignPerson()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("分配负责人")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'lbu_clue_person_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_unref(ClueMergeButton), {
                  data: selectedData.value,
                  onSuccess: _cache[22] || (_cache[22] = ($event: any) => (handleQueryChange('fetch'))),
                  appId: "cos_lbu"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("合并 ")
                  ]),
                  _: 1
                }, 8, ["data"])), [
                  [_directive_permission, 'lbu_clue_merge_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_unref(ImportBtn), {
                  action: "/lbu/api/clue/import",
                  templateUrl: "/lbu/api/clue/template/download",
                  onSuccess: _cache[23] || (_cache[23] = ($event: any) => (handleQueryChange('search')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导入 ")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'lbu_clue_import_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                  appId: "cos_lbu",
                  taskType: "301",
                  search: handledQueryParams(queryForm)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导出 ")
                  ]),
                  _: 1
                }, 8, ["search"])), [
                  [_directive_permission, 'lbu_clue_export_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  danger: "",
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (handleDelete()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'lbu_clue_del_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (handleExportDetails()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("导出明细")
                  ]),
                  _: 1
                })), [
                  [_directive_permission, 'lbu_clue_export_details_btn']
                ]),
                _createVNode(_component_a_button, {
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (handleRefund()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("退回")
                  ]),
                  _: 1
                })
              ]),
              bodyCell: _withCtx(({ column, record, text, index}) => [
                (column.dataIndex === 'customerName')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (record.collectionId===null)
                        ? (_openBlock(), _createBlock(FavoriteIcon, {
                            key: 0,
                            type: "add",
                            onClick: ($event: any) => (addFavorite(record,index))
                          }, null, 8, ["onClick"]))
                        : (_openBlock(), _createBlock(FavoriteIcon, {
                            key: 1,
                            type: "cancel",
                            onClick: ($event: any) => (cancelFavorite(record,index))
                          }, null, 8, ["onClick"])),
                      (record.clueStatus !== 8 && record.hasFollow === false)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "New"))
                        : _createCommentVNode("", true),
                      _createVNode(_component_router_link, {
                        class: "ant-table-cell-ellipsis",
                        to: `/lbu/salesClue/view?clueId=${record.clueId}`,
                        title: text
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text || '--'), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "title"])
                    ]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'channel')
                  ? (_openBlock(), _createBlock(ChannelText, {
                      key: 1,
                      appId: "cos_lbu",
                      paramCode: "lbu_source_channel",
                      value: text,
                      desc: record.channelExplain
                    }, null, 8, ["value", "desc"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'customerRegion')
                  ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                      key: 2,
                      appId: "cos_lbu",
                      value: text
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'clueStatus')
                  ? (_openBlock(), _createBlock(_component_dc_status, {
                      key: 3,
                      enums: _unref(statusEnum),
                      value: text
                    }, null, 8, ["enums", "value"]))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'label')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(record.label ? record.label.map((item) => item.labelName ).join('、') : '--'), 1))
                  : _createCommentVNode("", true),
                (column.type === 'money')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(formatThousandSeparator)(text)), 1))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'action')
                  ? (_openBlock(), _createBlock(_component_MoreButton, { key: 6 }, {
                      default: _withCtx(() => [
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (handleWriteFollowUp(record.clueId))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("写跟进 ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'lbu_clue_write_follow_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                          type: "link",
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (triggerAddOrEdit(record.clueId))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("编辑 ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'lbu_clue_edit_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                          type: "link",
                          workCode: record.follower,
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (handleTurnPotential(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("转为潜在客户 ")
                          ]),
                          _: 2
                        }, 1032, ["workCode", "disabled", "onClick"])), [
                          [_directive_permission, 'lbu_clue_potential_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (handleDelete(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("删除 ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'lbu_clue_del_btn']
                        ]),
                        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                          type: "link",
                          disabled: record.clueStatus === 8,
                          onClick: ($event: any) => (handleMap(record))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("签到地址 ")
                          ]),
                          _: 2
                        }, 1032, ["disabled", "onClick"])), [
                          [_directive_permission, 'lbu_clue_map_btn']
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["row-selection", "columns", "search"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ClueAssign, {
      ref_key: "clueAssignRef",
      ref: clueAssignRef,
      onFetch: _cache[28] || (_cache[28] = ($event: any) => (handleQueryChange('fetch')))
    }, null, 512),
    _createVNode(CustomerMaps, {
      ref_key: "customerMapsRef",
      ref: customerMapsRef
    }, null, 512),
    _createVNode(ExportDetails, {
      ref_key: "exportDetailsRef",
      ref: exportDetailsRef,
      appId: "cos_lbu",
      search: queryForm,
      taskTypeEnum: [
  { value: 311, label: '签到地址' },
  { value: 314, label: '在售平台' },
  { value: 317, label: '目的地国家' },
  { value: 320, label: '物流商' },
  { value: 323, label: '货物品类' },
  { value: 326, label: 'ERP系统' }
]
    }, null, 8, ["search"])
  ], 64))
}
}

})